import type { Corridor, DrillingAnalysisGroup } from '../../../shared/api/IDashboardService';
import { BaseParameterTypes, mnemonicToBaseParameter } from '../../../shared/baseParams';

function mapCorridorCurveName(curveName: string): BaseParameterTypes | null {
  if (curveName === 'ROPaverage') {
    return BaseParameterTypes.RATE_OF_PENETRATION;
  }

  return mnemonicToBaseParameter[curveName.toLowerCase()] ?? null;
}

function preferCorridorMatch(current: Corridor | null, candidate: Corridor): Corridor {
  if (current == null) {
    return candidate;
  }

  if (current.curveName === 'ROPaverage' && candidate.curveName !== 'ROPaverage') {
    return candidate;
  }

  return current;
}

export function findHeatmapCorridorMatches(
  group: DrillingAnalysisGroup,
  xParameter: BaseParameterTypes,
  yParameter: BaseParameterTypes,
): { x: Corridor | null; y: Corridor | null } {
  let xCorridor: Corridor | null = null;
  let yCorridor: Corridor | null = null;

  for (const corridor of group.corridors) {
    const mappedType = mapCorridorCurveName(corridor.curveName);

    if (!mappedType) {
      continue;
    }

    if (mappedType === xParameter) {
      xCorridor = preferCorridorMatch(xCorridor, corridor);
    }

    if (mappedType === yParameter) {
      yCorridor = preferCorridorMatch(yCorridor, corridor);
    }
  }

  return { x: xCorridor, y: yCorridor };
}
